module.exports = __webpack_public_path__ + "img/Monika-Suchan-302.0ba24638.jpg";